<template>
    <span class="custom-select">
        <button ref="button"
                :if="buttonId"
                class="custom-select__select-button primary-text primary-border"
                type="button"
                aria-haspopup="listbox"
                :aria-expanded="open ? 'true' : ''"
                :aria-labelledby="labelledBy"
                @click="emitOpen()"
                @keydown="handleKeydown($event)"
        >
            {{ text }} &nbsp;˅
        </button>
        <button v-if="displayClear"
                class="clear-button primary-background mb-3"
                type="button"
                @click="$emit('select', [''])"
                :aria-label="ariaLabel"
        >
            <span class="clear-button__icon secondary-text">&times;</span>
        </button>
    </span>
</template>

<script>
import { isOnDanish } from "../../../modernjs/utils/is-on-language";

    export default {
        props: {
            isMultiple: {
                type: Boolean,
            },
            options: {
                type: Array,
                required: true,
            },
            value: {
                type: Array,
                required: true,
            },
            labels: {
                type: Array,
                required: true,
            },
            open: {
                type: Boolean,
                required: true,
            },
            uniqueId: {
                type: Number,
                required: true,
            },
            labelId: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                default: '',
            },
            noClear: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            text () {
                return this.value.map(v => this.labels[this.options.indexOf(v)]).join(', ');
            },
            ariaLabel () {
                const labelText = this.label && this.label.split(':')[0] || '';
                return isOnDanish() ? `rydder ${labelText} filter` : `clear ${labelText} filter`;
            },
            displayClear () {
                return !this.noClear && (this.value.length > 1 || this.value.length === 1 && this.value[0]);
            },
            buttonId () {
                return `select-button-${this.uniqueId}`;
            },
            labelledBy () {
                return [ this.labelId ]
                    .filter(Boolean)
                    .join(' ');
            },
        },
        watch: {
            open (curr, prev) {
                if (!curr && prev) {
                    setTimeout(() => this.$refs.button.focus());
                }
            },
        },
        methods: {
            emitOpen () {
                this.$emit('open', true);
            },
            handleKeydown (e) {
                if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                    this.emitOpen();
                }
            },
        },
    };
</script>
